<script lang="ts">
  import Button from "../atoms/Button.svelte";
  import CableIcon from "../atoms/CableIcon.svelte";
  import Card from "../atoms/Card.svelte";
  import Heading from "../atoms/Heading.svelte";
  import Text from "../atoms/Text.svelte";
  import CustomContent from "../molecules/CustomContent.svelte";

  interface Props {
    confirmationContent?: string;
    confirmationType: "purchaseFlow" | "microProduction";
  }

  let { confirmationContent = undefined, confirmationType }: Props = $props();
</script>

{#if confirmationContent}
  <CustomContent content={confirmationContent} />
{:else}
  <Card class="py-12 px-4 flex">
    <div class="flex space-x-3.5">
      <CableIcon class="text-PurplePrimary my-auto" />
      <div>
        <Heading margin={false} variant="primary">Tack för din beställning!</Heading>
        {#if confirmationType === "purchaseFlow"}
          <Text class="mt-0.5" variant="primary"
            >Du har just tecknat ett 100 % förnybart elavtal. En beställningsbekräftelse landar
            snart i din inkorg.
          </Text>
        {:else}
          <Text class="mt-0.5" variant="primary"
            >Vi är glada över att du vill sälja överskottet av din förnybara el till oss, så andra
            kan ta del av den. Tack! En beställningsbekräftelse landar i din inkorg inom kort.</Text
          >
        {/if}
      </div>
    </div>
  </Card>
{/if}
<Button href="/" class="w-full my-9">Tillbaka till webbplatsen</Button>
